// Shared chart formatting + colour utilities for dashboard widgets.
// Extracted from `pages/Dashboards.jsx` (iter 41 refactor) — no behaviour change.
//
// iter-121.103 — Theme-aware chart palette. The Settings → Dashboard Theme
// picker writes `--chart-1..N` CSS variables on :root via
// `applyDashboardTheme` (see `lib/settings-context.jsx`). By referencing those
// CSS vars here, every dashboard widget (including AI-generated ones) picks
// up the tenant's chosen palette automatically, with no per-widget config
// changes. Fallback colours preserve the legacy hex palette when no theme
// has been configured (e.g. anonymous routes or fresh tenants).
export const CHART_COLORS = [
    "var(--chart-1, hsl(var(--primary)))",
    "var(--chart-2, #0ea5e9)",
    "var(--chart-3, #22c55e)",
    "var(--chart-4, #eab308)",
    "var(--chart-5, #f97316)",
    "var(--chart-6, #a855f7)",
    "var(--chart-7, #06b6d4)",
    "var(--chart-8, #ec4899)",
    "var(--chart-9, #64748b)", "var(--chart-10, #94a3b8)",
];
export const PIE_COLORS = [
    "var(--chart-1, hsl(var(--primary)))",
    "#0284c7", // Sky Blue
    "#059669", // Emerald Green
    "#d97706", // Amber Orange
    "#e11d48", // Rose Red
    "#c026d3", // Fuchsia Purple
    "#0d9488", // Teal
    "#475569", // Slate Gray
];

export function fmt(n, unit = "") {
    if (typeof n !== "number") return n;
    if (Math.abs(n) >= 1_000_000) return `${unit}${(n / 1_000_000).toFixed(1)}M`;
    if (Math.abs(n) >= 1_000) return `${unit}${(n / 1_000).toFixed(1)}K`;
    return `${unit}${n.toLocaleString()}`;
}

export const fmtNum = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return String(v ?? "");
    const abs = Math.abs(n);
    if (abs >= 1e9) return (n / 1e9).toFixed(abs >= 1e10 ? 1 : 2).replace(/\.0+$/, "") + "B";
    if (abs >= 1e6) return (n / 1e6).toFixed(abs >= 1e7 ? 1 : 2).replace(/\.0+$/, "") + "M";
    if (abs >= 1e3) return (n / 1e3).toFixed(abs >= 1e4 ? 1 : 2).replace(/\.0+$/, "") + "K";
    return Math.abs(n) < 10 ? n.toFixed(2).replace(/\.?0+$/, "") : Math.round(n).toLocaleString();
};

export const fmtAxis = (v) =>
    (typeof v === "number" ? fmtNum(v) : String(v ?? "").slice(0, 14));

export const fmtTooltip = (v, isCurrency) =>
    (typeof v === "number" ? `${isCurrency ? "$" : ""}${fmtNum(v)}` : String(v ?? ""));
